export default __webpack_public_path__ + "static/media/hero1.6f439cbb.png";